import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NewArtistsService, ArtistData } from "../services/NewArtistsService";
import "../styles/TrendingArtists.css";
import "../App.css";

export const NewArtists = () => {
  const [artists, setArtists] = useState<ArtistData[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadArtists = async () => {
      const data = await NewArtistsService.fetchNewArtists(18);
      setArtists(data);
      setLoading(false);
    };

    loadArtists();
  }, []);

  const handleNavigate = (rawName: string) => {
    if (!rawName) return;
    const param = rawName.replace(/\s+/g, "").toLowerCase();
    navigate(`/artist/${param}`);
  };

  if (loading) return null;

  return (
    <section className="trending-artists-section">
      <div className="trending-artists-header">
        <h2 className="scrollable-feed-header">Newly Added Artists</h2>
      </div>

      <div className="trending-artists-scroll-container">
        {artists.map((artist) => (
          <div
            key={artist.id}
            className="trending-artists-card"
            onClick={() => handleNavigate(artist.username || artist.name)}
            style={{ cursor: "pointer" }}
          >
            <div
              className="trending-artists-avatar"
              style={{
                backgroundImage: `url(${
                  artist.imageUrl || "https://via.placeholder.com/150"
                })`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
            <span className="trending-artists-name">{artist.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};